import * as React from "react";
import { hot } from "react-hot-loader";

const companyLogo = require("./../assets/img/logo.png");
import "./../assets/scss/App.scss";

class App extends React.Component<Record<string, unknown>, undefined> {
  public render() {
    return (
      <div className="app">
        <img src={companyLogo.default} height="100" />
        <h1>Coming Soon!</h1>
      </div>
    );
  }
}

declare let module: Record<string, unknown>;

export default hot(module)(App);
